{
  "documentTitle": "Sign in to Salt",
  "heading": "Welcome to Salt",
  "instructions": "Download the Salt app, then tap the Magic Link in the email again to sign in.",
  "codeLabel": "Your login code"
}
